module.exports = __webpack_public_path__ + "img/Pedidos.875e335b.png";